import { useQuery } from '@tanstack/react-query'

import { request } from '../../../lib/axios'
import { QueryConfig, ExtractFnReturnType } from 'Lib/react-query'
import { PaginationMetadata, PaginationParams } from '../../../types/pagination'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { Connection } from '../models'

export const getPlatformConnections = async (
  accountId: number,
  pagination?: PaginationParams,
  parentAccountId?: number
): Promise<{ connections: Connection[]; metadata?: PaginationMetadata } | Error> => {
  return await request<{ connections: Connection[] }>({
    url: `/accounts/${accountId}/connections${parentAccountId ? `/${parentAccountId}` : ''}`,
    method: 'GET',
    params: pagination,
  })
}

type QueryFnType = typeof getPlatformConnections

export const useGetPlatformConnections = ({
  config,
  pagination,
  parentAccountId,
}: {
  config?: QueryConfig<QueryFnType>
  pagination?: PaginationParams
  parentAccountId?: number // if provided - brings only children of the connection with this id
}) => {
  const { accountId } = useUserStore()
  const query = useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [
      'getPlatformsConnections',
      accountId,
      parentAccountId,
      pagination?.page,
      pagination?.limit,
      pagination?.search,
    ],
    queryFn: () => getPlatformConnections(accountId, pagination, parentAccountId),
    ...config,
  })

  const data = query.data && query.data instanceof Error ? undefined : query.data

  return { ...query, data }
}
